<script setup lang="ts">
defineProps<{
  article: CrystallizeArticle
}>()
</script>

<template>
  <NuxtLink :to="article.path" class="rounded-lg hover:bg-blurple-200 p-s md:p-l no-underline flex flex-col gap-s transition-colors group">
    <CrystallizeImage v-if="article.components?.headerImage" :image="article.components.headerImage" class="rounded-lg overflow-hidden h-48" img-class="object-cover group-hover:scale-105 transition-transform size-full" />
    <div v-else class="rounded-lg overflow-hidden bg-blurple-400 h-48 w-full flex items-center justify-center">
      <IconsLogoJuridika class="group-hover:scale-105 transition-transform fill-white w-3/5 h-full" />
    </div>

    <div class="text-ellipsis line-clamp-6">
      <h2 v-if="article.components?.title" class="title-s" v-text="article.components?.title" />

      <CrystallizeRichText v-for="(block, i) in article.components.leadParagraph" :key="i" class="mt-s" :block="block" />
    </div>

    <CrystallizePublished :date="article.components.published" class="text-base" />
  </NuxtLink>
</template>
